export enum CustomerState {
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED',
  CLOSED = 'CLOSED',
  INACTIVE = 'INACTIVE',
}

export const getCustomerStateLabel = (
  value: CustomerState | string
): string => {
  switch (value) {
    case CustomerState.ACTIVE:
      return $localize`Actif`;
    case CustomerState.BLOCKED:
      return $localize`Bloqué`;
    case CustomerState.CLOSED:
      return $localize`Fermé`;
    case CustomerState.INACTIVE:
      return $localize`Inactif`;
    default:
      return value;
  }
};

export const getCustomerStateClass = (value: CustomerState): string => {
  switch (value) {
    case CustomerState.ACTIVE:
      return 'success';
    case CustomerState.BLOCKED:
    case CustomerState.CLOSED:
      return 'danger';
    case CustomerState.INACTIVE:
      return 'warning';
  }
};
